import type { ReactElement } from 'react';
import { useMaieShell } from '@/config/maieShell';

/**
 * ONE PATH, TWO PAGES — whichever the browser's shell flag asks for.
 *
 * Three routes were REPLACED rather than added during the design port:
 * `/patients`, `/patients/:patientId` and `/directory`. The design page took
 * the path and the previous one moved to `.../legacy`, which is fine while the
 * flag is on and wrong the moment it is off: a ported page publishes its title,
 * search, primary action and docked pane as SHELL CHROME, and the old shell
 * does not consume any of that. The result is a bare table with no heading, no
 * search and no "+ Add patient" — the page is not merely unstyled, half of it
 * is not rendered at all.
 *
 * So `?maie=1` has to mean what it says: the new design ONLY when it is on.
 * With it off, these paths serve exactly the page they served before the port,
 * and `/patients/legacy` stays reachable for anyone who wants the old one while
 * the flag is on.
 *
 * This goes away with the flag — see `config/maieShell.ts`.
 */
export function ShellRoute({
  design,
  legacy,
}: {
  design: ReactElement;
  legacy: ReactElement;
}) {
  return useMaieShell() ? design : legacy;
}
